import { DeepLinkType } from "pages/api/deep-links/types";
import annotateRoute from "../api/deep-links/annotate.route";
import bookmarkRoute from "../api/deep-links/hit.route";
import createRoute from "../api/deep-links/create.route";
import deleteRoute from "../api/deep-links/delete.route";
import duplicateRoute from "../api/deep-links/duplicate.route";
import hitRoute from "../api/deep-links/bookmark.route";
import indexRoute from "../api/deep-links/index.route";
import readRoute from "../api/deep-links/read.route";
import regroupRoute from "../api/deep-links/regroup.route";
import updateRoute from "../api/deep-links/update.route";
import { post } from "./lib";

export const getDeepLinks = (org_id: string, user_id: string, type: string) =>
  post<typeof indexRoute>("/api/deep-links", { org_id, user_id, type });

export async function createDeepLink(
  org_id: string,
  user_id: string,
  type: string,
  state: string | any,
  name: string,
  scope?: string,
  group?: string,
  description?: string,
  thumbnail?: string
) {
  const legacyTypes = [DeepLinkType.EXPLORE];
  const takesJson = !legacyTypes.includes(type as DeepLinkType);
  const isJson = takesJson && typeof state !== "string";
  return post<typeof createRoute>(`/api/deep-links/create`, {
    user_id,
    org_id,
    type,
    state: isJson ? "" : state,
    json: isJson ? state : null,
    name,
    scope,
    group,
    description,
    thumbnail,
  });
}

export async function annotateDeepLink(link: {
  id: string;
  targetRole: string;
  useCase: string;
}) {
  return post<typeof annotateRoute>(`/api/deep-links/annotate`, link);
}

export async function updateDeepLink(
  org_id: string,
  user_id: string,
  link: {
    id: string;
    name?: string;
    description?: string;
    thumbnail?: string;
    group?: string;
    state?: any | string;
    scope?: "workspace" | "private" | "global";
  }
) {
  const isJson = typeof link.state !== "string";
  const state = isJson ? "" : link.state;
  const json = isJson ? link.state : null;
  return post<typeof updateRoute>(`/api/deep-links/update`, {
    user_id,
    org_id,
    ...link,
    state,
    json,
  });
}

export const readDeepLink = (id: string, orgId: string) =>
  post<typeof readRoute>(`/api/deep-links/read`, { org_id: orgId, id });

export const removeDeepLink = (id: string, orgId: string, userId: string) =>
  post<typeof deleteRoute>(`/api/deep-links/delete`, {
    user_id: userId,
    org_id: orgId,
    id,
  });

export const regroupDeepLinks = (
  orgId: string,
  userId: string,
  fromGroup: string,
  toGroup: string
) =>
  post<typeof regroupRoute>(`/api/deep-links/regroup`, {
    user_id: userId,
    org_id: orgId,
    fromGroup,
    toGroup,
  });

export const duplicateLink = (id: string, org_id: string, user_id: string) =>
  post<typeof duplicateRoute>(`/api/deep-links/duplicate`, {
    id,
    user_id,
    org_id,
  });

export const trackDeepLinkHit = (id: string, orgId: string) =>
  post<typeof hitRoute>(`/api/deep-links/hit`, { org_id: orgId, id });

export const bookmarkDeepLink = (id: string, orgId: string, userId: string) =>
  post<typeof bookmarkRoute>(`/api/deep-links/bookmark`, {
    action: "add",
    user_id: userId,
    org_id: orgId,
    id,
  });

export const unbookmarkDeepLink = (id: string, orgId: string, userId: string) =>
  post<typeof bookmarkRoute>(`/api/deep-links/bookmark`, {
    action: "remove",
    user_id: userId,
    org_id: orgId,
    id,
  });
